(function () {
  function initMilestones(root) {
    if (!root || root.dataset.milestonesInit === 'true') return;
    root.dataset.milestonesInit = 'true';

    var markers = Array.prototype.slice.call(root.querySelectorAll('[data-milestones-marker]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-milestones-panel]'));
    var activeDateEl = root.querySelector('[data-milestones-active-date]');
    var line = root.querySelector('[data-milestones-line]');
    var prevBtn = root.querySelector('[data-milestones-prev]');
    var nextBtn = root.querySelector('[data-milestones-next]');

    if (!markers.length) return;

    var currentIndex = 0;
    var autoplayEnabled = root.dataset.autoplay === 'true';
    var autoplayInterval = parseInt(root.dataset.autoplayInterval, 10) || 5000;
    var autoplayTimer = null;

    function positionActiveDate(marker) {
      if (!activeDateEl || !line) return;
      var lineRect = line.getBoundingClientRect();
      var markerRect = marker.getBoundingClientRect();
      var center = markerRect.left - lineRect.left + markerRect.width / 2;
      activeDateEl.style.left = center + 'px';
    }

    function scrollMarkerIntoView(marker) {
      if (!line) return;
      // 只有时间轴本身可以横向滚动时才处理（也就是手机端），
      // 电脑端 line 是 space-between 铺满整行的，不会溢出，直接跳过
      if (line.scrollWidth <= line.clientWidth) return;

      var targetScroll = marker.offsetLeft - line.clientWidth / 2 + marker.offsetWidth / 2;
      if (typeof line.scrollTo === 'function') {
        line.scrollTo({ left: targetScroll, behavior: 'smooth' });
      } else {
        line.scrollLeft = targetScroll;
      }
    }

    function setActive(index, opts) {
      opts = opts || {};
      if (index < 0) index = markers.length - 1;
      if (index >= markers.length) index = 0;
      currentIndex = index;

      markers.forEach(function (m, i) {
        m.classList.toggle('is-active', i === index);
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === index);
      });

      var activeMarker = markers[index];
      if (activeDateEl) {
        activeDateEl.textContent = activeMarker.querySelector('.milestones__marker-date').textContent;
      }
      positionActiveDate(activeMarker);

      // 手机端时间轴可横向滑动，把激活的日期滚动到可见区域
      // 注意：这里只滚动时间轴自己内部（line.scrollLeft），
      // 不能用 marker.scrollIntoView()，那个方法会连累整个页面一起滚动跳转
      scrollMarkerIntoView(activeMarker);

      if (!opts.silent) {
        restartAutoplay();
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || markers.length < 2) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        setActive(currentIndex + 1, { silent: true });
      }, autoplayInterval);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      if (!autoplayEnabled) return;
      startAutoplay();
    }

    markers.forEach(function (marker, i) {
      marker.addEventListener('click', function () {
        setActive(i);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        setActive(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        setActive(currentIndex + 1);
      });
    }

    // 鼠标悬停或手指触摸时暂停自动轮播，离开后恢复
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', restartAutoplay);
    root.addEventListener('touchstart', stopAutoplay, { passive: true });
    root.addEventListener('touchend', restartAutoplay, { passive: true });

    // 页面切到后台时暂停，避免不可见时空转
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        restartAutoplay();
      }
    });

    window.addEventListener('resize', function () {
      positionActiveDate(markers[currentIndex]);
    });

    // 手机端手动左右滑动时间轴时，实时重新计算大日期的位置
    if (line) {
      var scrollRaf = null;
      line.addEventListener('scroll', function () {
        if (scrollRaf) window.cancelAnimationFrame(scrollRaf);
        scrollRaf = window.requestAnimationFrame(function () {
          positionActiveDate(markers[currentIndex]);
        });
      });
    }

    // 初始定位（等字体/布局渲染完成后再算一次，避免位置不准）
    setActive(0, { silent: true });
    window.requestAnimationFrame(function () {
      positionActiveDate(markers[currentIndex]);
    });

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-milestones]').forEach(initMilestones);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-milestones]');
    if (root) {
      root.dataset.milestonesInit = 'false';
      initMilestones(root);
    }
  });
})();

